interface SectionHeadingProps {
  title: string;
  description?: string;
  center?: boolean;
  className?: string;
}

const SectionHeading = ({ 
  title, 
  description, 
  center = false, 
  className = '' 
}: SectionHeadingProps) => {
  return (
    <div className={`mb-16 ${center ? 'text-center' : ''} ${className}`}>
      <h2 className="text-3xl font-heading font-semibold text-neutral-800 mb-4">{title}</h2>
      {description && (
        <p className={`text-lg text-neutral-800 ${center ? 'max-w-3xl mx-auto' : ''}`}>
          {description}
        </p>
      )}
    </div>
  );
};

export default SectionHeading;
